import {
  SET_LIST_VOUCHER_DATA,
  SET_LIST_VOUCHER_DATA_TOTAL,
} from "../constant/actionTypes";

const initial_state = {
  listVoucherData: null,
  listVoucherDataTotal: 0,
};

export default (state = initial_state, action) => {
  switch (action.type) {
    case SET_LIST_VOUCHER_DATA:
      return {
        ...state,
        loading: false,
        listVoucherData: action.listVoucherData,
      };

    case SET_LIST_VOUCHER_DATA_TOTAL:
      return {
        ...state,
        loading: false,
        listVoucherDataTotal: action.listVoucherDataTotal,
      };

    default:
      return { ...state };
  }
};
